import { atom } from 'jotai';
import type { SessionEvent } from '@localagent/sdk';
import { configureAtomDevtools } from '../utils/tracking';

/**
 * The mounted chat surface's live event log, published for views that render
 * something derived from it — the search results panel projects the agent's
 * `search` tool results from here (app-shell ADR-021).
 *
 * The surface publishes rather than the consumer reading the SDK's singleton
 * session atom: the consumer would then depend on WHICH component owns the
 * session and when it resolves, and a view rendering an empty list because it
 * bound a moment too early is indistinguishable from an agent that found
 * nothing. `getEventData` rides along because a large event's heavy field is
 * hydrated on demand and only the surface holds the live session to fetch it.
 */
export interface ChatSurfaceEvents {
  events: readonly SessionEvent[];
  getEventData: (seq: number) => Promise<Record<string, unknown>>;
}

export const chatSurfaceEventsAtom = configureAtomDevtools(
  atom<ChatSurfaceEvents | null>(null),
  'chat/surfaceEvents'
);
